import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { FormValidationService } from '../../../core/services/form-validation.service';
import { ApiError } from '../../../core/models/common/api-error';
import { Store } from '@ngrx/store';
import { ToastService } from '../../../core/services/toast.service';
import { firstValueFrom, take, takeUntil } from 'rxjs';
import { DestroyableComponent } from '../../../shared/components/destroyable/destroyable.component';
import { selectAuthUser, selectAuthVendor } from '../../../core/store/reducers';
import { Vendor } from '../../../core/models/entities/vendor';
import { VendorsService } from '../../../core/services/vendors.service';
import { authActions } from 'angular/app/core/store/auth';

@Component({
  selector: 'app-grace-period-form',
  template: `
    <form>
      <app-text-input
        label="À compter de la date où le client effectue sa réservation, il peut annuler gratuitement dans les :"
        name="grace_period_hours"
        [control]="form.get('grace_period_hours')"
        append="heures après sa réservation"
      ></app-text-input>

      <div class="my-8 flex items-center justify-end gap-x-6">
        <app-button
          data-cy="cancel-button"
          (click)="onCancel.emit()"
          variant="link"
          >Annuler
        </app-button>
        <app-button
          data-cy="save-button"
          icon="check"
          (click)="submit()"
          variant="secondary"
          [loading]="sendingData"
          >Valider
        </app-button>
      </div>
    </form>
  `,
  standalone: false,
})
export class GracePeriodFormComponent
  extends DestroyableComponent
  implements OnInit
{
  @Output() onCancel = new EventEmitter<void>();
  @Output() gracePeriodSaved = new EventEmitter<Vendor>();
  vendor$ = this.store.select(selectAuthVendor);
  form: UntypedFormGroup;
  sendingData = false;

  constructor(
    private formValidationService: FormValidationService,
    private vendorsService: VendorsService,
    private store: Store,
    private toastService: ToastService,
  ) {
    super();
  }

  ngOnInit() {
    this.vendor$.pipe(take(1)).subscribe((vendor) => {
      this.form = new UntypedFormGroup({
        grace_period_hours: new UntypedFormControl(
          vendor.grace_period_hours ?? '',
        ),
      });
    });
  }

  async submit() {
    if (!this.formValidationService.validate(this.form)) return;

    try {
      this.sendingData = true;
      const user = await firstValueFrom(
        this.store.select(selectAuthUser).pipe(take(1)),
      );
      const vendor = await this.vendorsService.updateGracePeriod(
        this.form.value,
      );
      this.store.dispatch(
        authActions.findCurrentUserSuccess({ user: { ...user, vendor } }),
      );
      this.gracePeriodSaved.emit(vendor);
      this.toastService.success(
        'La condition d’annulation a été enregistrée avec succès.',
      );
    } catch (exception) {
      this.formValidationService.displayApiValidationErrors(
        this.form,
        exception as ApiError,
      );
    }
    this.sendingData = false;
  }
}
